import React from 'react'

export default function WorkflowSummary() {
  return (
    <div className="bg-accent-50 border border-accent-200 rounded-lg p-4">
      <h4 className="font-semibold text-accent-900 mb-2">Workflow Summary</h4>
      <div className="text-sm text-accent-700 space-y-1">
        <p>• <strong>Another Child:</strong> Copies ALL data (steps 1-6) except child-specific info, starts at Step 3</p>
        <p>• <strong>Referral:</strong> Creates user accounts and sends login credentials to referrals</p>
        <p>• <strong>Referral Tracking:</strong> Monitor your referrals' progress through the enrollment process</p>
        <p>• <strong>Job Application:</strong> Apply to become a sales agent and work under your original agent</p>
        <p>• <strong>Done:</strong> Completes enrollment and returns to campaign home</p>
      </div>
    </div>
  )
}
